import './Logo.css';
import { JEFF } from '../../config/jeff.ts';

interface LogoProps {
  /** `sm` for the header, `lg` for the hero. */
  size?: 'sm' | 'md' | 'lg';
  /** Renders the comb mark above the J. Dropped at the smallest size. */
  withMark?: boolean;
  className?: string;
}

/**
 * The wordmark.
 *
 * The name in ink, the TLD in coop red, and a three-lobed comb sitting on the
 * J — the only concession to the fact that the analyst is a chicken. The letters
 * are real text, so it stays selectable, searchable and legible at any zoom; only
 * the comb is drawn.
 *
 * Split at the dot via `appNameParts`, which is also where the hero size wraps.
 */
export function Logo({ size = 'md', withMark = true, className }: LogoProps) {
  const [head, tail] = JEFF.appNameParts;

  return (
    <span className={['logo', `logo--${size}`, className].filter(Boolean).join(' ')}>
      {withMark && (
        <svg className="logo__comb" viewBox="0 0 34 14" aria-hidden="true" focusable="false">
          <path
            d="M2 13.2c0-3.4 1-5.6 3-6.7 1.2-.7 2.6-.6 3.6.3.6.5 1 1.2 1.3 2 .5-2.5 1.7-4.3 3.5-5.3 1.5-.8 3.2-.6 4.4.5.8.7 1.3 1.7 1.6 2.8.7-3 2.2-5 4.4-6 1.7-.8 3.6-.4 4.8.9 1.3 1.4 1.9 3.5 1.9 6.3v5.2Z"
            fill="currentColor"
          />
        </svg>
      )}
      <span className="logo__head">{head}</span>
      <span className="logo__tail">{tail}</span>
    </span>
  );
}
